import React from 'react';
import BriefDetailModal from './BriefDetailModal';

export type { BriefDetailType } from './types';

type BriefEditModalProps = Omit<React.ComponentProps<typeof BriefDetailModal>, 'initialIsEditing'>;

const BriefEditModal: React.FC<BriefEditModalProps> = (props) => {
    return <BriefDetailModal {...props} initialIsEditing={true} />;
};

export default BriefEditModal;
